import script from "./chart2.vue?vue&type=script&setup=true&lang=js"
export * from "./chart2.vue?vue&type=script&setup=true&lang=js"

import "./chart2.vue?vue&type=style&index=0&id=a748fed4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a748fed4"]])

export default __exports__